import { render, staticRenderFns } from "./BuyCar.vue?vue&type=template&id=1ef701a0&scoped=true"
import script from "./BuyCar.vue?vue&type=script&lang=js"
export * from "./BuyCar.vue?vue&type=script&lang=js"
import style0 from "./BuyCar.vue?vue&type=style&index=0&id=1ef701a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef701a0",
  null
  
)

export default component.exports